import fetch from "../fetch";

export default ({ params = {} } = {}) =>
  fetch({ path: `/common/underwriter-roles`, params });
